var moment = require('moment');

module.exports = function(angularModule) {
  angularModule.directive('cmTimePeriodSelector', function (timePeriodService) {

    return {
      restrict: "E",
      scope: {
        offset: '=',
        periodType: '=',
        onUpdate: '='
      },
      template: `
        <div class="time-period-selector-container">
          <div class="btn-group d-flex">
            <a tabindex="0" ng-click="setOffset(offset + 1)" class="btn btn-outline-info flex-grow-0" ng-class="{disabled: !canGoPrev}">
              <i class="far fa-arrow-left" ></i>
            </a> 
            <select class="btn btn-outline-info flex-grow-1" name="periodSelector" ng-model="selectedPeriod" ng-change="selectedPeriodChanged()">
              <option ng-repeat="period in selectablePeriods" value="{{period.url}}">{{period.display}}</option>
            </select>
            <a tabindex="0" ng-click="setOffset(offset - 1)" class="btn btn-outline-info flex-grow-0" ng-class="{disabled: !canGoNext}">
              <i class="far fa-arrow-right"></i>
            </a>
          </div>
          <div class="alert p-2 alert-warning">{{summary}}</div>
        </div>`,
      link: function ($scope, $element) {

        $scope.selectablePeriods = timePeriodService.selectablePeriods;

        var selectedPeriod = timePeriodService.periodForUrl($scope.periodType);
        $scope.selectedPeriod = selectedPeriod.url;

        $scope.selectedPeriodChanged = function () {
          var end = selectedPeriod.millis * ($scope.offset);
          selectedPeriod = timePeriodService.periodForUrl($scope.selectedPeriod);
          $scope.offset = Math.max(Math.floor(end / selectedPeriod.millis), 0);
          $scope.periodType = selectedPeriod.url;
          onUpdate();
        };

        $scope.setOffset = function(periodCount) {
          $scope.offset = periodCount;
          onUpdate();
        };

        function reinitialize() {
          $scope.canGoPrev = $scope.offset * selectedPeriod.millis < timePeriodService.millis.perMonth;
          $scope.canGoNext = $scope.offset > 0;
          var { start, end } = timePeriodService.periodToDateRange({ periodType: selectedPeriod.url, offset: $scope.offset });
          $scope.summary = moment(start).fromNow() + ' to ' + moment(end).fromNow();
        }

        function onUpdate() {
          reinitialize();
          $scope.onUpdate && $scope.onUpdate(selectedPeriod.url, $scope.offset);
        }

        reinitialize()

      }
    }
  });
}
